// extracted by mini-css-extract-plugin
export default {"container":"gY-z","title":"hY-z","link":"iY-z"};